import {
  Box,
  BoxProps,
  HStack,
  useColorModeValue,
  Wrap,
  WrapItem,
  WrapProps,
} from '@chakra-ui/react';
import { Text } from '@main/complykit/components/text';

export type ChartLegendItem = {
  key: string;
  label: string;
  color: string;
};

export type ChartLegendSwatchProps = BoxProps & {
  color: string;
};

export function ChartLegendSwatch({ color, ...props }: ChartLegendSwatchProps) {
  return <Box w="8px" h="8px" borderRadius="full" bg={color} flexShrink={0} {...props} />;
}

export type ChartLegendProps = Omit<WrapProps, 'children'> & {
  items: ChartLegendItem[];
};

export function ChartLegend({
  items,
  spacing = 4,
  justify = 'flex-start',
  w = 'full',
  ...props
}: ChartLegendProps) {
  return (
    <Wrap spacing={spacing} justify={justify} w={w} {...props}>
      {items.map((item) => (
        <WrapItem key={item.key}>
          <HStack spacing={2}>
            <ChartLegendSwatch color={item.color} />
            <Text size="sm" color="muted">
              {item.label}
            </Text>
          </HStack>
        </WrapItem>
      ))}
    </Wrap>
  );
}
